import BaseModel from "./base/baseModel";

export default class SetorModel extends BaseModel {
    id? = 0;
    descricao = "";
}
